import { render, staticRenderFns } from "./PBXComponent.vue?vue&type=template&id=399938e4&"
import script from "./PBXComponent.vue?vue&type=script&lang=ts&"
export * from "./PBXComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PBXComponent.vue?vue&type=style&index=0&id=399938e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports